import { RootPage } from '../page';
import $api from '../../api';
import * as siteConfig from '../../site-config/config';
import { VisualEventsGroupModel } from '../../models/Gen/BaseModels';
import VisualEventEditor from './components/visualEventEditor';
import EditorIframePositionBar from '../../components/editor/editorIframePositionBar';
import EditorSettingsComponent from '../../components/editor/editorSettings';
import EditorSettings from '../../models/EditorSettings';
import Switcher from '../../components/switcher';
import createUUID from '../../utils/uuid';

class VisualEventsEditorView extends RootPage {
    constructor() {
        super();

        this.isLoaded = ko.observable(false);

        this.isDirty = ko.observable();

        Switcher();

        const getProperSaveButtons = () => {
            if (!window.auth.isImpVo) {
                return { css: 'btn btn-success', onclick: this.saveAndClose.bind(this), text: 'Save & Close' }
            } else {
                return null
            }
        }

        window.topToolbarButtons = [
            /*{ css: 'btn btn-success', onclick: this.save.bind(this), text: 'Save & Close' }*/ getProperSaveButtons(),
            { css: 'btn fas fa-cog text-white mr-2', onclick: this.toggleSettings.bind(this), title: 'Settings' },
            //{ css: 'btn fas fa-question text-white mr-0', onclick: this.showHelp.bind(this, 'editor_hints'), title: 'Help' },
            //{ css: 'btn fas fa-eye text-white ' + (isFlagOn('editor_new_save') ? 'mr-5' : 'mr-4'), onclick: this.preview.bind(this), title: 'Preview' },
        ];

        VisualEventEditor(this);

        EditorIframePositionBar(this);
        EditorSettingsComponent(this);

        this.isMinimized = ko.observable(false);
        this.selectedVisualEvent = ko.observable(null);
        this.visualEventsGroup = ko.observable();

        window.addEventListener('message', (msg) => {
            if (msg.data.action === 'elementSelected') {
                document.dispatchEvent(new CustomEvent('cardElementQueried', { detail: { cardId: msg.data.cardId, query: msg.data.query, url: msg.data.url } }));
                this.autosave();
            } else if (msg.data.action === 'relocateCard') {
                document.dispatchEvent(new CustomEvent('relocateCard', { detail: { cardId: msg.data.cardId } }));
            } else if (msg.data.action === 'elementSelectorChanged') {
                document.dispatchEvent(new CustomEvent('cardSelectorChanged', { detail: { cardId: msg.data.cardId, query: msg.data.query } }));
                this.autosave();
            }
        });

        window.onerror = (e) => {
            this.logSaveThanSorry();
        }

        this.settingsShown = ko.observable(false);
        this.editorSettings = new EditorSettings();
    }

    onInit() {
        VisualEventsGroupModel.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.descriptor = {
                create: function (options) {
                    return new siteConfig.VisualEventsGroupDescriptor(options.data);
                }
            };
        };

        var visualEventsAutosave = sessionStorage.getItem('visualEventsAutosave');

        if (visualEventsAutosave) {
            this.visualEventsGroup(new VisualEventsGroupModel(JSON.parse(visualEventsAutosave)));
        } else {
            this.visualEventsGroup(new VisualEventsGroupModel(this.getServerSideData('visualEventsGroup')));
        }

        this.isLoaded(true);

        this.showWelcomeModalIfNeeded();
    }

    showWelcomeModalIfNeeded() {
        //try {
        //    if (window.auth && window.auth.user && window.auth.user.SignUpAt >= '2022-01-19') {
        //        const welcomeShown = localStorage.getItem('pf_editor_hints_welcome_dialog_shown');

        //        if (!welcomeShown) {
        //            $api.users.getSettings(
        //                { key: 'hints_welcome_shown' },
        //                {},
        //                (val) => {
        //                    if (!val || Object.keys(val).length === 0) {
        //                        $api.users.setSettings(
        //                            {},
        //                            { key: 'hints_welcome_shown', value: '1' },
        //                            () => {
        //                            }
        //                        );

        //                        this.showHelp('hints-welcome');
        //                    }

        //                    localStorage.setItem('pf_editor_hints_welcome_dialog_shown', '1');
        //                }
        //            );
        //        }
        //    }
        //} catch (e) {
        //    console.log('Welcome dialog err', e);
        //}
    }

    preview() {
        window.parent.postMessage({ action: 'preview-helps', descriptor: JSON.stringify(ko.toJS(this.getDescriptor())) }, '*');
    }

    setSelectedVisualEvent(help) {
        this.selectedVisualEvent(help);
    }

    deselectCard() {
        this.autosave();
        document.dispatchEvent(new CustomEvent('closeCard', { detail: { cardId: ko.toJS(this.selectedVisualEvent().help.id) } }));
        document.dispatchEvent(new CustomEvent('deselectCard', { detail: { cardId: ko.toJS(this.selectedVisualEvent().help.id) } }));
    }

    removeCard(card) {
        var index = this.getDescriptor().visualEvents.indexOf(card);
        if (index !== -1) {
            this.getDescriptor().visualEvents.splice(index, 1);
        }
        this.autosave();
    }

    saveAndClose() {
        this.save(() => {
            window.parent.close();
        });
    }

    save(saved, error) {
        //console.log('FDSAFSAD', ko.mapping.toJS(this.visualEventsGroup()));
        $api.visualEvents.saveDescriptor(
            { projectCode: auth.project.UniqueCode, id: this.visualEventsGroup().id() },
            ko.mapping.toJS(this.getDescriptor()),
            (resp) => {
                this.isDirty(false);

                if (saved) saved();
            },
            (err) => {
                if (error) error(err);
                this.logSaveThanSorry();
            },
            (err) => {
                if (error) error(err);
                this.logSaveThanSorry();
            }
        );
    }

    autosave() {
        const objToSave = JSON.stringify(this.visualEventsGroup().toJS(), (k, v) => (k === '__ko_mapping__' || k === '_ModelExtender' || k === 'toJS') ? undefined : v);

        try {
            const oldSavedObj = sessionStorage.getItem('visualEventsAutosave');
            requestAnimationFrame(() => {
                if (!!oldSavedObj && oldSavedObj != objToSave) {
                    document.dispatchEvent(new Event('pfruits_editor_dirty'));
                    this.isDirty(true);
                }
            });

            sessionStorage.setItem('visualEventsAutosave', objToSave);
        } catch (e) {
            this.logSaveThanSorry();
            alert('We have encountered an error while autosaving. Save your work by clicking on the Save and exit and open the editor again.');
        }
    }

    getDescriptor() {
        return this.visualEventsGroup().descriptor();
    }

    addNew() {
        var descriptor = this.getDescriptor();

        if (descriptor.visualEvents() === null) {
            descriptor.visualEvents([]);
        }

        var newHelp = new siteConfig.VisualEventDescriptor();

        newHelp.name('Event #' + (descriptor.visualEvents().length + 1));
        newHelp.targetUrl(new siteConfig.StringValue());

        descriptor.visualEvents.push(newHelp);

        this.autosave();
    }

    toggleSettings() {
        if (this.settingsShown()) {
            this.editorSettings.saveToLocalStorage();
        }
        this.settingsShown(!this.settingsShown());
    }

    hideSettings() {
        this.settingsShown(false);
    }

    logSaveThanSorry() {
        //const objToSave = JSON.stringify(this.contextHelp().toJS(), (k, v) => (k === '__ko_mapping__' || k === '_ModelExtender' || k === 'toJS') ? undefined : v);

        //let tId = null;
        //try {
        //    tId = this.contextHelp().id();
        //} catch (e) {

        //}

        //$api.projects.autosaveThing(
        //    { projectCode: auth.project.UniqueCode },
        //    { ref: window.location.href, contextHelpId: tId, content: objToSave },
        //    () => { }
        //);
    }

    showHelp(id) {
        window.parent.postMessage({
            action: 'pf_show_help',
            id
        }, '*');
    }
}

export default VisualEventsEditorView;